import React, { useEffect } from "react";
import { ModalPadrao, LabelPadrao, InputPadrao, LoadingContainerPadrao } from "../../components/Base";
import { fetch } from "../../actions";
import * as api from "./api";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import Mensagens from "../../components/Mensagens";
import { connect } from "react-redux";
import { BtnCancelar, BtnGravar, BtnListar, BtnSair } from "../../components/Buttons";
import { InputNumero } from "../../components/InputNumero";
import TabelaPadrao from "../../components/TabelaPadrao";

function TransferenciaReceberRejeitar({ visible, onCancel, ...props }) {
  const [transferencias, listar, loading] = useFetch(() => api.obterPendentes(props.fetch));
  const [detalhe, listarDetalhe, loadingDetalhe, setDetalhe] = useFetch();
  const [receber, recebendo] = useSave(() => api.receber(props.fetch, detalhe), () => { listar(); setDetalhe(null); Mensagens.showSucesso("Transferência recebida com sucesso!"); });
  const [rejeitar, rejeitando] = useSave(() => api.rejeitar(props.fetch, detalhe.id), () => { listar(); setDetalhe(null); Mensagens.showSucesso("Transferência rejeitada com sucesso!"); });

  useEffect(() => {
    if (visible)
      listar();

  }, [visible]);

  return <>
    <ModalPadrao visible={visible} onCancel={onCancel} title="Receber/Rejeitar Transferência" width={800} footer={<BtnSair onClick={onCancel} />}>
      <LoadingContainerPadrao style={{ minHeight: 300 }} loading={loading || loadingDetalhe}>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <div style={{ flex: 1, marginRight: 10 }}>
            <LabelPadrao noMargin>Caixa atual</LabelPadrao>
            <InputPadrao value={props.auth.user} disabled />
          </div>
          <BtnListar onClick={listar} />
        </div>
        <TabelaPadrao style={{ marginTop: 25 }} columns={columns} data={transferencias} setEdit={v => listarDetalhe(() => api.obterById(props.fetch, v.id))} />
      </LoadingContainerPadrao>
    </ModalPadrao>

    <ModalPadrao visible={!!detalhe} title="Transferência detalhe" width={800} closable={false} footer={<>
      <BtnGravar txt="Receber" onClick={receber} showConfirm loading={recebendo} disabled={rejeitando} />
      <BtnCancelar txt="Rejeitar" onClick={rejeitar} showConfirm loading={rejeitando} disabled={recebendo} />
      <BtnSair onClick={() => setDetalhe(null)} disabled={recebendo || rejeitando} />
    </>}>
      <div style={{ minHeight: 300 }}>
        {!!detalhe && <>
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <LabelPadrao noMargin>Empresa</LabelPadrao>
              <InputPadrao value={props.auth.empresa.fantasia} disabled />
            </div>
            <div style={{ width: "calc(25% - 10px)", margin: "0 10px" }}>
              <LabelPadrao noMargin>Número</LabelPadrao>
              <InputPadrao value={detalhe.numero} disabled />
            </div>
            <div style={{ width: "25%" }}>
              <LabelPadrao noMargin>Valor</LabelPadrao>
              <InputNumero value={detalhe.valor} disabled />
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <div style={{ width: "50%", marginRight: 10 }}>
              <LabelPadrao>Caixa de origem</LabelPadrao>
              <InputPadrao value={detalhe.usuarioOrigem} disabled />
            </div>
            <div style={{ width: "50%" }}>
              <LabelPadrao>Caixa de destino</LabelPadrao>
              <InputPadrao value={props.auth.user} disabled />
            </div>
          </div>
        </>}
      </div>

    </ModalPadrao>
  </>;
}
const mapStateToProps = state => ({ auth: state.auth });

export default connect(mapStateToProps, { fetch })(TransferenciaReceberRejeitar);

const columns = [
  {
    Header: "Número",
    accessor: "numero",
  },
  {
    Header: "Caixa origem",
    accessor: "usuarioOrigem",
  },
  {
    Header: "Data solicitação",
    accessor: "data",
    tipo: "dthr"
  },
  {
    Header: "Valor",
    accessor: "valor",
    tipo: "rs"
  },
];